<template>
    <div>
        <bar-chart :chart-data="datacollection" :options="options" style="height:470px;"></bar-chart>
    </div>
</template>

<script>
    import BarChart from "../js/bar.js";
    export default {
        components: {
            BarChart
        },
        data() {
            return {
                datacollection: {},
                options: null,
                filterData:{

                }
            }
        },
        mounted() {
            this.fillData()
        },
        methods: {
            getUpdatedData() {
                this.fillData();
            },
            fillData() {
                request({
                    url: "patenkinders-per-year",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.datacollection = response.data.data;
                });
                this.options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                padding: 20,
                                beginAtZero: true,
                                precision: 0
                            },
                            gridLines: {
                                drawTicks: false,
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                padding: 20,
                            },
                            gridLines: {
                                drawTicks: false,
                            }
                        }]
                    },
                    hover: {
						mode: null
					},
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Widgets/chart/components/YearwisePatenkinder.vue